import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { ReactNode } from "react";

interface SettingsSectionBodyProps {
  children: ReactNode;
  className?: string;
}

export const SettingsSectionBody = ({
  children,
  className,
}: SettingsSectionBodyProps) => (
  <div className={classNames("flex flex-col gap-5 px-6 pb-5 pt-2", className)}>
    {children}
  </div>
);
